import { Box } from '@mui/material'
import { CardContainer, CardTitle, TrendWrapper } from '../common/styles'
import { HeaderWrapper } from './styles'
import { MetricCardProps } from './types'
import { ProgressRow } from '../ProgressRow'
import { ProgressContainer, ProgressBar, ValueText } from '../ProgressRow/styles'
import {
  NEUTRAL_COLOR,
  calculatePercentage,
  getProgressColor,
  getTrendSymbol,
  getTrendColor
} from '../common/utils'
import { formatToPercentage } from '../../../../../../utils/format'
import { useTheme } from '@mui/material'
import { BootstrapTooltip } from 'components/BootstrapTooltip'
import { UnavailableValue } from 'components/UnavailableValue'
import { FUTURE_SALES_MESSAGE, isFieldDisabled } from 'utils/reportDisabledFields'
import { formatValue } from '../ProgressRow/utils'

export const MetricCard = ({
  disabledReason,
  title,
  format = 'currency',
  value = 0,
  expectedValue = 0,
  lastYearPercentage
}: MetricCardProps) => {
  const theme = useTheme()
  const disabled = isFieldDisabled(disabledReason)
  const progress = disabled ? 0 : calculatePercentage(value, expectedValue)
  const progressColor = disabled ? NEUTRAL_COLOR : getProgressColor(progress)

  return (
    <CardContainer>
      <HeaderWrapper>
        <CardTitle>{title}</CardTitle>
        <Box sx={{ width: theme.spacing(1) }} />
        {typeof lastYearPercentage === 'number' && (
          disabled
            ? (
              <UnavailableValue message={FUTURE_SALES_MESSAGE}>
                <TrendWrapper component='span' color={NEUTRAL_COLOR}>-</TrendWrapper>
              </UnavailableValue>
              )
            : (
              <TrendWrapper color={getTrendColor(lastYearPercentage)}>
                {getTrendSymbol(lastYearPercentage)}
                {' '}
                {formatToPercentage(Math.abs(lastYearPercentage))}
              </TrendWrapper>
              )
        )}
      </HeaderWrapper>

      {disabled
        ? (
          <div>
            <ProgressContainer>
              <BootstrapTooltip title={FUTURE_SALES_MESSAGE}>
                <ValueText small color={progressColor}>-</ValueText>
              </BootstrapTooltip>
              <ValueText small>{formatValue(expectedValue, format)}</ValueText>
            </ProgressContainer>
            <ProgressBar small progresscolor={progressColor} value={0} />
          </div>
          )
        : (
          <ProgressRow
            small
            leftValue={value}
            leftFormat={format}
            leftColor={progressColor}
            rightValue={expectedValue}
            rightFormat={format}
            progressValue={progress}
            progressColor={progressColor}
          />
          )}
    </CardContainer>
  )
}
